<!-- No items message -->
<div class="no-items-message" *ngIf="noItems">{{ 'table.algorithms.no_pipelines' | translate }}</div>

<!-- Table content -->
<table mat-table [dataSource]="pipelineList" class="usage-table" *ngIf="!noItems">
  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ 'table.algorithms.columns.name' | translate }}</th>
    <td mat-cell *matCellDef="let pipeline" class="name-cell">
      <div class="pipeline-name-cell">
        <mat-icon
          class="pipeline-name-icon"
          aria-hidden="true"
          matTooltip="{{ 'table.algorithms.tooltips.navigate_pipeline' | translate }}"
          [matTooltipShowDelay]="800"
          (click)="navigateToPipeline.emit(pipeline.id)"
        >
          link
        </mat-icon>
        <span class="pipeline-name-text">{{ resolveName(pipeline.name) }}</span>
      </div>
    </td>
  </ng-container>

  <!-- Task Column -->
  <ng-container matColumnDef="task">
    <th mat-header-cell *matHeaderCellDef>{{ 'table.algorithms.columns.task' | translate }}</th>
    <td mat-cell *matCellDef="let pipeline" class="task-cell">{{ resolveTask(pipeline.task) | async }}</td>
  </ng-container>

  <!-- Environment Column -->
  <ng-container matColumnDef="env">
    <th mat-header-cell *matHeaderCellDef>{{ 'table.algorithms.columns.env' | translate }}</th>
    <td mat-cell *matCellDef="let pipeline" class="env-cell">{{ resolveEnvironment(pipeline.env) }}</td>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let pipeline" class="actions-cell">
      <button class="icon-button edit" type="button" (click)="onEditClick(pipeline); $event.stopPropagation()">
        <i class="ri-pencil-line"></i>
      </button>
      <button class="icon-button delete" type="button" (click)="onDeleteClick(pipeline); $event.stopPropagation()">
        <i class="ri-delete-bin-6-line"></i>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let pipeline; columns: displayedColumns"></tr>
</table>
